module.exports = __webpack_public_path__ + "img/tuandui1.302f68eb.png";